import { createContext } from 'react';
export var ProstoreSsrContext = createContext(null);
var ProstoreSsrManager = /** @class */ (function () {
    function ProstoreSsrManager(_a) {
        var isServer = _a.isServer, initialStates = _a.initialStates;
        this.isServer = false;
        this.states = {};
        this.promises = new Set();
        this.disabled = false;
        this.isServer = isServer || false;
        this.states = initialStates || this.states;
    }
    ProstoreSsrManager.prototype.registerPromise = function (promise) {
        var _this = this;
        this.promises.add(promise);
        promise.then(function () {
            _this.promises.delete(promise);
        });
    };
    ProstoreSsrManager.prototype.hasPromises = function () {
        return this.promises.size > 0;
    };
    ProstoreSsrManager.prototype.waitForCurrentPromises = function () {
        return Promise.all(this.promises);
    };
    ProstoreSsrManager.prototype.getState = function (key) {
        if (this.disabled)
            return null;
        return this.states[key];
    };
    ProstoreSsrManager.prototype.setState = function (key, value) {
        if (this.disabled)
            return;
        this.states[key] = value;
    };
    ProstoreSsrManager.prototype.getStates = function () {
        return this.states;
    };
    ProstoreSsrManager.prototype.setDisabled = function (value) {
        this.disabled = value;
    };
    return ProstoreSsrManager;
}());
export { ProstoreSsrManager };
//# sourceMappingURL=ProstoreSsrContext.js.map